export default __webpack_public_path__ + "static/media/StepsInactive02.b6e0a3b4.svg";